const API_BASE = '/api';

async function handleResponse(response) {
  const data = await response.json();

  if (!response.ok) {
    const err = new Error(data.error || 'An error occurred');
    err.status = response.status;
    err.isProtected = data.isProtected || false;
    err.reason = data.reason || '';
    throw err;
  }

  return data;
}

export async function getCurrentUser() {
  const response = await fetch(`${API_BASE}/auth/me`, {
    credentials: 'include'
  });
  return handleResponse(response);
}

export async function searchUsers(query) {
  const response = await fetch(`${API_BASE}/users/search?q=${encodeURIComponent(query)}`, {
    credentials: 'include'
  });
  return handleResponse(response);
}

export async function getUser(userId) {
  const response = await fetch(`${API_BASE}/users/${userId}`, {
    credentials: 'include'
  });
  return handleResponse(response);
}

export async function resetPassword(userId, forceChangeOnNextSignIn = true) {
  const response = await fetch(`${API_BASE}/users/${userId}/reset-password`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ forceChangeOnNextSignIn })
  });
  return handleResponse(response);
}

export async function resetMfa(userId) {
  const response = await fetch(`${API_BASE}/users/${userId}/mfa-methods`, {
    method: 'DELETE',
    credentials: 'include'
  });
  return handleResponse(response);
}

export async function getMfaMethods(userId) {
  const response = await fetch(`${API_BASE}/users/${userId}/mfa-methods`, {
    credentials: 'include'
  });
  return handleResponse(response);
}

export async function checkProtectedUser(userId) {
  const response = await fetch(`${API_BASE}/users/${userId}/protected`, {
    credentials: 'include'
  });
  return handleResponse(response);
}

export async function unlockUser(userId) {
  const response = await fetch(`${API_BASE}/users/${userId}/unlock`, {
    method: 'POST',
    credentials: 'include'
  });
  return handleResponse(response);
}
